import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FaShieldAlt, FaPercent, FaHeadset, FaBell } from 'react-icons/fa';
import "./HomeHeroRefined.css";

const WhyBook = () => {
    const reasons = [
        {
            icon: <FaShieldAlt size={28} />,
            title: "Assured Protection",
            desc: "Instant & full refunds on cancellations with Travel Insurance.",
            color: "#e63946"
        },
        {
            icon: <FaBell size={28} />,
            title: "Intelligent Alerts",
            desc: "Save up to 40% with smart fare alerts and price drops.",
            color: "#f2bc06"
        },
        {
            icon: <FaPercent size={28} />,
            title: "Exclusive Deals",
            desc: "Access member-only rates and seasonal vacation coupons.",
            color: "#053355"
        },
        {
            icon: <FaHeadset size={28} />,
            title: "24/7 Support",
            desc: "Dedicated travel experts available round the clock.",
            color: "#457b9d"
        }
    ];

    return (
        <section className="why-book-refined">
            <Container>
                <div className="text-center mb-5">
                    <h2 className="gallery-main-title">
                        Why Book With <span className="text-highlight">SkyPort Destinations?</span>
                    </h2>
                    <div className="title-sep"></div>
                </div>

                <Row>
                    {reasons.map((item, index) => (
                        <Col lg={3} md={6} key={index} className="mb-4">
                            <div className="flight-deal-card text-center" style={{ height: "100%", padding: "40px 20px" }}>
                                <div style={{ 
                                    color: item.color,
                                    marginBottom: "20px"
                                }}>
                                    {item.icon}
                                </div>
                                <h3 style={{ fontSize: "19px", fontWeight: "800", color: "#053355", marginBottom: "12px" }}>
                                    {item.title}
                                </h3>
                                <p style={{ color: "#6c757d", fontSize: "14px", lineHeight: "1.6", margin: 0 }}>
                                    {item.desc}
                                </p>
                            </div>
                        </Col>
                    ))}
                </Row>
            </Container>
        </section>
    );
};

export default WhyBook;
